import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CareerEnquiryLayer from "../components/CareerEnquiryLayer";

const CareerEnquiryPage = () => {
  return (
    <MasterLayout>
      <CareerEnquiryLayer />
    </MasterLayout>
  );
};

export default CareerEnquiryPage;
